import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { BaseInlineUpdateComponent, BaseUpdateComponent, InlineContainerService } from 'yt-ng-framework';
import { EPrijemnicaStavka } from './eprijemnica-stavka';
import { EPrijemnicaStavkaUpdateComponent } from './eprijemnica-stavka-update.component';
import { Observable, of } from 'rxjs';
@Component({
    selector: 'yt-eprijemnica-stavka-inline-update',
    templateUrl: './eprijemnica-stavka-inline-update.component.html'
})
export class EPrijemnicaStavkaInlineUpdateComponent
    extends BaseInlineUpdateComponent<EPrijemnicaStavka> {
    constructor(protected inlineContainerService: InlineContainerService<EPrijemnicaStavka>
        , private ngZone: NgZone

    ) {
        super(inlineContainerService);
    }
    @ViewChild('baseUpdate', { static: false })
    innerUpdateComponent: EPrijemnicaStavkaUpdateComponent;

    toggleCollapse() {
        this.collapsed = !this.collapsed;
    }

    ngAfterViewInit() {
        console.log("VIEW INIT => innerUpdateComponent =", this.innerUpdateComponent);
    }
}
